<template>
	<div class="model">
        <div class="model-wrap">
            <p class="model-toast" v-if="msg">{{msg}}</p>
            <div class="model-left">
                <img  @dragstart.prevent  src="../assets/img_denglu.png" alt="">
            </div>
            <div class="model-con" @click.stop="">
                <p class="model-tit">登录/注册</p>
                <div class="myInput">
                    <div class="model-input" style="border-bottom: 1px solid #E6E6E6;">
                        <div>+86</div>
                        <input type="text" placeholder="请输入手机号" v-model="mobile">
                    </div>
                    <div class="model-input model-code">
                        <div>验证码</div>
                        <input type="text" placeholder="请输入验证码" v-model="yzmcode">
                        <div class="myline"></div>
                        <p :class="['model-codebtn',`${isClickSend && 'codegray'}`]" @click="sendCode">{{ !isClickSend ? "发送验证码" : `重新发送(${codeNum})s` }}</p>
                    </div>
                </div>
                <!-- <p class="model-btn" @click="handleBtn">{{type == 1 || type == 2 ? '登录/注册':'确认注销'}}</p> -->
                <p class="model-btn" @click="handleBtn">登录/注册</p>
                <div class="other">
                    <div class="other-line"></div>
                    <div class="other-txt">其他方式登录</div>
                    <div class="other-line"></div>
                </div>
                <div class="wxLogin">
                    <div class="wxLogin-item cursorPointer" @click="wxLogin">
                        <img  @dragstart.prevent  src="../assets/icon_login_weixin.png" alt="">
                        <span>微信登录</span>
                    </div>
                    <!-- <div class="wxLogin-item" style="">
                        <img  @dragstart.prevent  src="../assets/icon_login_qq.png" alt="">
                        <span>QQ登录</span>
                    </div> -->
                </div>
                <div class="yinsi">
                    <!-- <div v-if="!checkAgree" class="yuan cursorPointer" @click="handleAgree(true)"></div> -->
                    <img  @dragstart.prevent  v-if="!checkAgree" class="cursorPointer" src="../assets/checkbox_normal.png" alt="" @click="handleAgree(true)">
                    <img  @dragstart.prevent  v-else class="cursorPointer" src="../assets/icon_login_checkbox.png" alt="" @click="handleAgree(false)">
                    <div class="yinsiCont">我已阅读并同意
                        <span class="cursorPointer" @click="isShowXieyi = 2">《服务协议》</span>和
                        <span class="cursorPointer" @click="isShowXieyi = 1">《隐私政策》</span></div>
                </div>
            </div>
        </div>
        <div class="loginSucc" v-if="isSuccess">
            <div class="loginSucc_bg"></div>
            <div class="loginSucc_content">
                <p>登录成功</p>
                <div>
                    <img  @dragstart.prevent  src="../assets/icon_dengluchenggong.png" alt="">
                </div>
            </div>
        </div>
        <div class="xieyi" v-if="isShowXieyi != 0">
            <div class="xieyi_bg">
                <div class="xieyi_body">
                    <user-privacy v-if="isShowXieyi == 1"></user-privacy>
                    <user-service v-if="isShowXieyi == 2"></user-service>
                    <div class="xieyi_close cursorPointer" @click="isShowXieyi = 0">关 闭</div>
                </div>
            </div>
        </div>
        <!-- <slide-verification></slide-verification> -->
    </div>
</template>

<script setup>
	import userService from "../components/userAgreement/userService.vue"
	import userPrivacy from "../components/userAgreement/userPrivacy.vue"
	import slideVerification from "../components/slideVerification.vue"
	import { getCurrentInstance,ref,reactive,watch,onMounted,onUnmounted,toRefs,defineEmits } from "vue";
	import {navTo, refreshUserInfo} from '../utils/utils'
    import {getcodeApi,loginApi,useInfoApi,oauthQrcode } from '@/utils/api'
    import Cookies from 'js-cookie'
    import { useRoute, useRouter } from 'vue-router'
    let route = useRoute()
	const router = useRouter()
    const type = ref(1)
    // 使用defineEmits创建名称，接受一个数组
    let zxconf = ref(false)
	// 定时器
    let clearId = ref(null);
    // 倒计时时间
    let codeNum = ref(60);
    // 手机号
    let mobile = ref("");
    // 验证码
    let yzmcode = ref('');
    let msg = ref('');
    let isClickSend = ref(false);// 发送验证码
    let checkAgree = ref(false);// 点击同意协议
    let isSuccess = ref(false)
    let isShowXieyi = ref(0)
    watch(msg, (newValue, oldValue) => {
        if(newValue != oldValue){
            setTimeout(()=>{
                msg.value = ''
            },3000)
        }
    });
    onMounted(()=>{
        if(router.currentRoute.value.query.msg){
            msg.value = router.currentRoute.value.query.msg
        }
    })
    onUnmounted(()=>{
       
    })
    const emit = defineEmits(['refreshLogin'])
    // 是否发送了验证码 防止连点
    const sendCode = async () => {
        if (isClickSend.value || codeNum.value != 60) return;
        var reg3 = /^0?(13|15|17|18|14|19)[0-9]{9}$/   //请输入正确的手机号
        if (!reg3.test(mobile.value)) {
            msg.value = '请输入正确的手机号'
            return
        }
        try{
            let {code} = await getcodeApi({phone:mobile.value});
            if(code == 200){
                msg.value = '验证码发送成功~'
                isClickSend.value = true;
                // yzmcode.value = code
                clearId.value = setInterval(() => {
                    codeNum.value--;
                    if (codeNum.value == 0) {
                        clearInterval(clearId.value);
                        codeNum.value = 60;
                        isClickSend.value = false;
                    }
                }, 1000);
            }
        }catch(err){
            msg.value = err.message
        }

    };
    const handleBtn = async()=>{
        var reg3 = /^0?(13|15|17|18|14|19)[0-9]{9}$/   //请输入正确的手机号
        if(!mobile.value){
            msg.value = '请填写手机号！'
        }else if (!reg3.test(mobile.value)) {
            msg.value = '请输入正确的手机号'
            return
        }else if(!yzmcode.value){
            msg.value = '请填写验证码！'
        }else if(!checkAgree.value){
            msg.value = '请阅读并同意《服务协议》和《隐私政策》！'
        }else{
            try{
                loginApi({phone:mobile.value,code:yzmcode.value}).then(res=>{
                    if(res.code == 200){
	                    emit('refreshLogin')
                        refreshUserInfo()
                        // msg.value = '登录成功！'
                        isSuccess.value = true
                        setTimeout(()=>{
                            router.back();
                        },1000)
                    }
                }).catch(errs=>{
                    if(errs.code == 400){
                        msg.value = errs.msg
                    }else if(errs.code == 1002){
                        msg.value = errs.msg
                    }
                })
            }catch(err){
                console.log(err,'catch')
                msg.value = err.message
            }
        }
    }
    onMounted(() => {
        clearInterval(clearId)
    })
    
    const handleAgree =  (val) => {
        checkAgree.value = val
    }
    let wxLogin = ()=>{
        if(!checkAgree.value){
            msg.value = '请阅读并同意《服务协议》和《隐私政策》！'
            return
        }
        oauthQrcode({p:'wechat',redirectUrl:localStorage.getItem('currPath')}).then(res=>{
            if(res.code == 200){
                let aDom = document.createElement('a')
                aDom.href = res.data.url
                aDom.target = 'self'
                aDom.click()
            }
        })
    }
</script>

<style lang="scss" scoped>
   .model{
    width:100%;
     .model-wrap{
        width: 1188px;
    	margin: 0 auto;
        display: flex;
        padding: 130px 40px 122px;
    }
    .model-toast{
        position: absolute;
        top: 150px;
        left: 50%;
        transform: translateX(-50%);
        padding: 8px 37px;
        font-size: 14px;
        line-height: 20px;
        color: #CB2945;
		background-color: rgba(203, 41, 69, 0.06);
        border-radius: 6px;
    }
    &-left{
        width: 50%;
        height: 394px;
        img{
            margin-top: 90px;
            width: 100%;
            height: 100%;
        }
    }
	.model-con{
        width: 680px;
        background-color: #FFFFFF;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-left:60px;
        .model-tit{
            width: 100%;
            text-align: left;
            height: 56px;
            font-size: 24px;
            color: #333333;
            line-height: 56px;
            margin-bottom: 30px;
            margin-left: 40px;
        }
        .myInput{
            border-radius: 6px;
            border: 1px solid #E6E6E6;
            margin-bottom: 30px;
            .model-input{
                display: flex;
                align-items: center;
                padding: 0 30px;
                div{
                    width: 84px;
                    font-size: 18px;
                    color: #333333;
                    line-height: 24px;
                    text-align: left;
                }
                input{
                    flex: 1;
                    // width: 100%;
                    height: 80%;
                    border: none;
                    outline: none;
                    font-size: 18px;
                    color: #999999;
                    line-height: 24px;
                    padding: 24px 0;
                    display: flex;
                }
                .myline{
                    width: 1px;
                    height: 40px;
                    border: 1px solid #E6E6E6;
                    margin: 0 30px;
                }
            }
        }
        .model-code{
            cursor: pointer;
            .model-codebtn{
                font-size: 18px;
                line-height: 24px;
                
                color: #CB2945;
            }
            .codegray{
                color: #CDCDCD;
            }
        }
        .model-btn{
            cursor: pointer;
            width: 420px;
            height: 50px;
            background: linear-gradient(202deg, #E7537B 0%, #CB2945 100%);
            border-radius: 25px;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 48px;
            text-align: center;
            margin-bottom: 30px;
        }
        .model-tip{
            cursor: pointer;
            margin: -30px 0 30px;
            font-size: 22px;
            p{color: #666666;}
            display: flex;
            align-items: center;
            .model-noc{
                width: 20px;
                height: 20px;
                border-radius: 10px;
                border: 2px solid #979797;
                margin-right: 16px;
            }
            .model-cho{
                background: url('../assets/icon_queren.png') no-repeat center center/20px 20px;
                border: none;
            }
        }
    }
    .other{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 56px;
        &-line{
            width: 200px;
            height: 1px;
            border: 1px solid #E6E6E6;
        }
        &-txt{
            font-size: 16px;
            color: #999999;
            line-height: 24px;
            margin: 0 20px;
        }
    }
    .wxLogin{
        width: 360px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        &-item{
            display: flex;
            align-items: center;
        }
        img{
            width: 30px;
            height: 30px;
        }
        span{
            margin-left: 10px;font-size: 16px;
            color: #333333;
            line-height: 22px;
        }
    }
    .yinsi{
        display: flex;
        align-items: center;
        .yuan{
            width: 16px;
            height: 16px;
            border-radius: 8px;
            border: 1px solid #999999;
        }
        img{
            width: 16px;
            height: 16px;
        }
        .yinsiCont{
            margin-left: 8px;
            font-size: 16px;
            color: #999999;
            line-height: 22px;
            span{
                color: #CB2945;
            }
        }
    }
        .xieyi{
        width: 100%;
        height: 100%;
        /*background: red;*/
        position:fixed;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
		flex-direction: column;
        z-index: 999;

        .xieyi_bg{
            width: 100%;
            height: 100%;
            /*background: red;*/
            position:absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.2);
        }
        .xieyi_body{
            position: absolute;
            top: 150px;
            left: 50%;
            transform: translateX(-50%);
            width: 1188px;
            height: 600px;
            background-color: #fff;
            overflow-y: scroll;
            padding: 40px 20px;
            border: #eee solid 1px;
            box-shadow: 0px 0px 8px 0px rgba(29, 30, 31, 0.3);
            border-radius: 20px;
        }
        .xieyi_close{
            background-color: #eee;
            padding: 10px 70px;
            text-align: center;
            border-radius: 40px;
            margin-top: 20px;
            width: 300px;
            margin: 030px auto;
        }
    }
   }
   .loginSucc{
	width: 100%;
	height: 100%;
	/*background: red;*/
	position:fixed;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 999;

    .loginSucc_bg{
        width: 100%;
        height: 100%;
        /*background: red;*/
        position:absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.4);
    }
    .loginSucc_content{
		width: 340px;
        height: 195px;
        background: #FFFFFF;
        position: relative;
        z-index: 20;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
		overflow: hidden;
        p{
            font-size: 20px;
            
            color: #333333;
            line-height: 28px;
            margin-bottom: 30px;
        }
        div{
            width: 67px;
            height: 67px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
